import api from '@/utils/api';

const { baseApi } = window.GlobalConfig;

export const searchDataAuth = data => {
    return api.post(`${baseApi}/dataAuthority/getDataAuthorityList`, data);
};

export const addDataAuth = data => {
    return api.post(`${baseApi}/dataAuthority/addDataAuthorityBatch`, data);
};

export const deleteDataAuth = data => {
    return api.post(`${baseApi}/dataAuthority/deleteDataAuthorityBatch`, data);
};

export const updateDataAuth = data => {
    return api.post(`${baseApi}/dataAuthority/updateDataAuthorityBatch`, data);
};

export const UpdateAllDataAuth = data => {
    return api.post(`${baseApi}/dataAuthority/saveDataAuthorityHigh`, data);
};

export const UpdateAreaDataAuth = data => {
    return api.post(`${baseApi}/dataAuthority/saveDataAuthorityHigh`, data);
};

export const QueryAllDataAuth = ({ userId }) => {
    return api.get(`${baseApi}/dataAuthority/getDataAuthority4All/${userId}`);
};

export const QueryAreaDataAuth = ({ userId }) => {
    return api.get(`${baseApi}/dataAuthority/getDataAuthority4AreaRegion/${userId}`);
};
